import { textPropertyConfig } from './text/cell-renderer.js';

export const propertyPresets = {
  textPropertyConfig,
};
